import { createNamespacedHelpers } from 'vuex'
import * as API from 'src/api/dev/message'
import * as T from './types'

const {
    mapState,
    mapActions,
    mapGetters,
    mapMutations
} = createNamespacedHelpers('message')

export {
    mapState,
    mapActions,
    mapGetters,
    mapMutations
}

const module = {
    namespaced: true,

    state: {
        msgList: [],
        msgTotal: 0,
        unreadMsgList: [],
        unreadTotal: 0,
    },

    mutations: {
        [T.SET_MSG_LIST](state, payload) {
            const { items, total } = payload
            state.msgList = items
            state.msgTotal = total
        },
        [T.SET_UNREAD_MSG_LIST](state, payload) {
            const { items, total } = payload
            state.unreadMsgList = items
            state.unreadTotal = total
        }
    },

    actions: {
        [T.GET_MSG_LIST]({ commit }, payload) {
            return API.getMsgList(payload)
                .then(data => {
                    commit(T.SET_MSG_LIST, data)
                    return data
                })
        },
        [T.GET_UNREAD_MSG_LIST]({ commit }, payload) {
            return API.getMsgList(payload)
                .then(data => {
                    commit(T.SET_UNREAD_MSG_LIST, data)
                    return data
                })
        },
        [T.SET_MSG_READ](store, payload) {
            return API.setMsgRead(payload)
        },
        [T.DELETE_MSG](store, payload) {
            return API.deleteMsg(payload)
        },
    },
}

export default module
